export * from './PersonalAreaPage';
